module.exports = __webpack_public_path__ + "img/toolsAndSystems.66253342.svg";